/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function Login() {
  const history = useHistory();
  const auth = useContext(AuthContext);
  const LS = localStorage.getItem("OrusSystem");
  const defaultStorage = {
    protocol: window.location.protocol.replace(":", ""),
    host: window.location.hostname,
    port: window.location.port,
  };
  const storage = LS ? JSON.parse(LS) : defaultStorage;
  const server = `${storage.protocol ? storage.protocol + "://" : ""}${
    storage.host ?? ""
  }${storage.port ? ":" + storage.port : ""}`;
  const [state, setState] = useState({
    load: false,
    email: "",
    password: "",
    txtHost: server,
    hostShow: server ? false : true,
  });
  const COMPANY = "Optica Madero";
  const inputEmail = useRef();
  const inputPassword = useRef();

  // Functions
  const handleLogin = () => {
    const patterEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!state.email) {
      return window.Swal.fire({
        icon: "error",
        text: "El campo de correo electronico es requerido",
        showConfirmButton: false,
        timer: 2500,
        position: "top center",
      }).then(() => {
        inputEmail.current.focus();
      });
    }

    if (/^@./.test(state.email)) {
      const user = state.email.replace("@", "");

      state.email = `${user}@domain.com`;
    } else if (!patterEmail.test(state.email)) {
      return window.Swal.fire({
        icon: "error",
        text: "El usuario debe de ser un correo valido",
        showConfirmButton: false,
        timer: 2500,
        position: "top center",
      }).then(() => {
        inputEmail.current.focus();
      });
    }

    if (
      !["domain.com", "opticamadero.com"].includes(state.email.split("@")[1])
    ) {
      return window.Swal.fire({
        icon: "error",
        text: "El dominio de este correo no es aceptado",
        showConfirmButton: false,
        timer: 2500,
        position: "top center",
      }).then(() => {
        setState({
          ...state,
          email: "",
        });
      });
    }

    if (!state.password) {
      return window.Swal.fire({
        icon: "error",
        text: "El campo de constraseña es requerido",
        showConfirmButton: false,
        timer: 2500,
        position: "top center",
      }).then(() => {
        inputPassword.current.focus();
      });
    }

    if (state.password.length < 8) {
      return window.Swal.fire({
        icon: "error",
        text: "El password debe de tener al menos 8 caracteres",
        showConfirmButton: false,
        timer: 2500,
        position: "top center",
      }).then(() => {
        inputPassword.current.focus();
      });
    }

    setState({
      ...state,
      load: true,
    });

    auth
      .setSession({ email: state.email, password: state.password })
      .then((res) => {        
        setState({
          ...state,
          load: false,
        });

        if (!res.status) {
          let message = res.message;

          if (res.data?.errors) {
            message = res.data?.errors[Object.keys(res.data.errors)[0]][0];
          }

          if (!message && res.data) message = res.data.message;

          return window.Swal.fire({
            icon: "error",
            text: message,
            showConfirmButton: false,
            timer: 2500,
            position: "top center",
          });
        }

        history.push("/");
      });
  };
  const handleKeyEnter = (key, fn) => {
    if (key === "Enter") {
      fn();
    }
  };
  const handleChangeServer = () => {
    const { txtHost } = state;

    if (!txtHost) {
      return window.Swal.fire({
        icon: "error",
        text: "El campo de servidor no puede estar vacio",
        showConfirmButton: false,
        timer: 2500,
        position: "top center",
      });
    }

    let urlString = txtHost.trim().toLowerCase();
    // Remove trailing slash
    if (urlString.endsWith("/")) {
      urlString = urlString.slice(0, -1);
    }

    // Add protocol if missing
    if (!urlString.includes("://")) {
      urlString = `${window.location.protocol}//${urlString}`;
    }

    try {
      const url = new URL(urlString);
      const protocol = url.protocol.replace(":", "");
      const host = url.hostname;
      const port = url.port || "";

      localStorage.setItem(
        "OrusSystem",
        JSON.stringify({
          ...storage,
          protocol,
          host,
          port,
          token: "",
        })
      );

      setState({
        ...state,
        txtHost: `${protocol}://${host}${url.port ? ":" + port : ""}`,
        hostShow: false,
      });

      window.Swal.fire({
        icon: "success",
        text: "Cambio de servidor exitoso",
        showConfirmButton: false,
        timer: 2500,
        position: "top center",
      });
    } catch (e) {
      window.Swal.fire({
        icon: "error",
        text: "La URL del servidor no es válida",
        showConfirmButton: false,
        timer: 2500,
        position: "top center",
      });
    }
  };
  const handleEmailEnter = () => {
    if (state.email) inputPassword.current.focus();
  };

  useEffect(() => {
    if (auth.auth?.isLogged) {
      history.push("/");
    }
  }, []);

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <a href="#logo" onClick={(e) => e.preventDefault()}>
            <b className="text-primary">Orus</b> LTE
          </a>
        </div>

        <div className="rounded shadow-lg card">
          <div className="card-body login-card-body">
            <p className="login-box-msg text-uppercase">
              <span className="p-2 badge badge-secondary">{COMPANY}</span>
              <br />
              <small className="text-muted text-lowercase">{`<${state.txtHost}>`}</small>
            </p>
            <form autoComplete="off">
              <div className="mb-0 input-group">
                <input
                  type="email"
                  className="form-control text-lowercase"
                  placeholder="Correo electonico"
                  onChange={({ target }) =>
                    setState({ ...state, email: target.value.toLowerCase() })
                  }
                  onKeyPress={({ key }) =>
                    handleKeyEnter(key, handleEmailEnter)
                  }
                  defaultValue={state.email}
                  autoComplete="false"
                  ref={inputEmail}
                  autoFocus={state.email ? false : true}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-user"></span>
                  </div>
                </div>
              </div>

              <div className="mt-3 input-group">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Contraseña"
                  onChange={({ target }) =>
                    setState({ ...state, password: target.value })
                  }
                  onKeyPress={({ key }) => handleKeyEnter(key, handleLogin)}
                  defaultValue={state.password}
                  autoComplete="false"
                  ref={inputPassword}
                  autoFocus={
                    state.email ? (state.password ? false : true) : false
                  }
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock"></span>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="my-3 col-12">
                  <a
                    href="#tools"
                    onClick={(e) => {
                      e.preventDefault();
                      setState({ ...state, hostShow: !state.hostShow });
                    }}
                    className="text-muted"
                  >
                    <i className="mx-1 fas fa-wifi"></i> Servidor
                  </a>
                  {state.hostShow ? (
                    <div className="mb-3 input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Servidor"
                        autoComplete="off"
                        onChange={({ target }) =>
                          setState({
                            ...state,
                            txtHost: target.value.toLowerCase(),
                          })
                        }
                        defaultValue={state.txtHost}
                        onKeyPress={({ key }) =>
                          handleKeyEnter(key, handleChangeServer)
                        }
                      />
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span className="fas fa-server"></span>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="text-center col-12">
                  <button
                    type="button"
                    className={
                      state.load
                        ? "btn btn-outline-secondary btn-block"
                        : "btn btn-primary btn-block"
                    }
                    onClick={handleLogin}
                    disabled={state.load ? true : false}
                  >
                    {state.load ? (
                      <div className="spinner-border text-secondary">
                        <span className="sr-only">Loading...</span>
                      </div>
                    ) : (
                      "Iniciar session"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
